import React, { Component } from "react";
import { Paginator } from "primereact/paginator";
import { Navigate } from "react-router-dom";
import AnSpinner from "../../core/components/other/AnSpinner";
import AnDataGrid from "../../core/components/other/AnDataGrid";
import { OffhireReportService } from "../services/OffhireReportService";

class SameVesselReportSelector extends Component {
  state = {
    vesselReports: [],
    selectedReport: null,
    totalRecords: 0,
    lazyParams: {
        first: 0,
        rows: 10,
        page: 1,
        // sortField: null,
        // sortOrder: null,
        // filters: {
        //     'name': { value: '', matchMode: 'contains' },
        //     'country.name': { value: '', matchMode: 'contains' },
        //     'company': { value: '', matchMode: 'contains' },
        //     'representative.name': { value: '', matchMode: 'contains' },
        // }
    },

    onProgress: true,
    isLoggedIn: true,
    isLoaded: false,
    error: "",
  };

  onFetchSuccess = (response, firstFetch = false) => {
    if (response.status === 200) {
      const { records, records_count} = response?.data ?? {};

      this.setState({
        onProgress: false,
        isLoaded: true,
        vesselReports: records ?? [],
        totalRecords: records_count ?? 0
      });
    }
  };

  onFetchFailed = (error) => {
    if (error.response.status === 401) {
      this.setState({ isLoggedIn: false });
    }
    if (error.response.status === 404) {
      this.setState({
        onProgress: false,
        isLoaded: true,
        error: "No data found for the given input.",
      });
    } else {
      this.setState({
        onProgress: false,
        isLoaded: false,
        error: "Error: " + error.response.statusText + ", (Not found)",
      });
    }
    this.setState({
      vesselReports: [],
    });
  };

  componentDidMount() {
    this.fetchReports();
  }

  fetchReports = (page=1) => {
    this.setState({ onProgress: true});
    const {vesselCode} = this.props;
    const filters = {
        vessel_codes: vesselCode ? [vesselCode]:[],
        years: [],
        months: [],
        page,
      };

    OffhireReportService.getFilteredNonMemo(filters)
      .then(
        (response) => this.onFetchSuccess(response, true),
        this.onFetchFailed
      );
  };

    onPage = (event) => {
        this.fetchReports(event?.page+1);
        this.setState({ lazyParams:event});
    }

  setSelectedReport = (selectedReport) => {
    const { onSelect } = this.props;
    onSelect && onSelect(selectedReport);
    console.log(selectedReport);
    // set selected report
    this.setState({
      ...this.state,
      selectedReport,
    });
  };

  handleSelectionChanged = (event) => {
    const selectedRows = event.api.getSelectedRows();
    this.setSelectedReport(selectedRows?.[0] ?? null);
  };

  render() {
    // debugger;
    const { isLoaded, isLoggedIn, onProgress, vesselReports, selectedReport, lazyParams, totalRecords } = this.state;
    if (!isLoggedIn) return <Navigate replace to="/sessionends" />;
    if (onProgress) {
      return <AnSpinner/>;
    }
    if (!vesselReports || vesselReports?.length < 1)
      return <>No Reports available!</>;

    vesselReports.forEach((rep) => {
      rep.formatted = {};
      rep.formatted.is_planned = rep?.offhire_report_technical?.is_planned
        ? "Planned"
        : "Unplanned";
      rep.formatted.delay_start_at_gmt =
        rep?.offhire_report_technical?.delay_start_at_gmt;
      rep.formatted.delay_end_at_gmt =
        rep?.offhire_report_technical?.delay_end_at_gmt;
      rep.formatted.offhire_days =
        rep?.offhire_report_technical?.delay_end_at_gmt -
        rep?.offhire_report_technical?.delay_start_at_gmt;
      rep.formatted.place = rep?.offhire_report_technical?.location?.toUpperCase() === "SEA"
      ? rep?.offhire_report_technical?.sea?.name ?? ""
      : rep?.offhire_report_technical?.port?.name ?? "";
      });

      const {technicalReport} = this.props;
    const columns = [
      { header: "Vessel", field: "vessel_name" },
      { header: "Locaiton", field: "offhire_report_technical.location" },
      { header: "Place", field: "formatted.place" },
      { header: "Delay Start (GMT)", field: "formatted.delay_start_at_gmt" },
      { header: "Delay End (GMT)", field: "formatted.delay_end_at_gmt" },
      { header: "Total Time (day)", field: "formatted.offhire_days" },
      { header: "Offhire/Stoppage", field: "activity" },
      { header: "Planned/Unplanned", field: "formatted.is_planned" },
      { header: "Type", field: "offhire_report_technical.event_type.name" },
      { header: "Machinery", field: "offhire_report_technical.machinery.machinery_type.name" },
      { header: "Machinery Subtype", field: "offhire_report_technical.machinery.name" },
      { header: "Details", field: "reason" },
      { header: "Report Status", field: "report_status" },
    ];

    return (
      <div className="row-col p-3">
        <AnDataGrid
          rowData={vesselReports}
          columns={columns}
          height="60vh"
          rowSelection="single"
          showSelectionColumn
          onSelectionChanged={this.handleSelectionChanged}
          isRowSelectable={(node) =>
            node?.data?.offhire_report_technical?.id !== technicalReport?.id
          }
          rowHeight={34}
          style={{ fontSize: "0.75rem" }}
        />
        <div className="mt-3">
          <Paginator
            first={lazyParams.first}
            rows={lazyParams.rows ?? 10}
            totalRecords={totalRecords}
            rowsPerPageOptions={[10]}
            onPageChange={this.onPage}
            template="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          />
        </div>
      </div>
    );
  }
}

export default SameVesselReportSelector;
